import { useContext, useMemo } from 'react'
import { UseFormWatch } from 'react-hook-form'
import { InternationalPrice, isCountryCode, Rate, Rates } from 'src/subscribe'
import { Context } from 'src/Subscribe_'
import type { FieldValues } from './RecipientsInformation'

const InternationalPricingNote = ({
  note,
  rates,
  watch,
}: {
  note: string
  rates: Rates
  watch: UseFormWatch<FieldValues>
}) => {
  const { state } = useContext(Context)
  const countryCode = watch('address.country_code')

  const internationalPrice: InternationalPrice | null = useMemo(() => {
    if (
      countryCode === 'US' ||
      !isCountryCode(countryCode) ||
      !state.values.rate_nid
    ) {
      return null
    }
    const rate: Rate | undefined = rates[state.values.rate_nid]
    if (rate === undefined) {
      return null
    }
    const ip: InternationalPrice | undefined =
      rate.international_prices[countryCode]
    return ip || null
  }, [countryCode, rates, state.values.rate_nid])

  const text: string | null = useMemo(() => {
    if (!internationalPrice) {
      return null
    }
    return note
      .replace(/\{country\}/, internationalPrice.country)
      .replace(/\{amount_in_dollars\}/, internationalPrice.amount_in_dollars)
  }, [internationalPrice])

  if (!text) {
    return null
  }
  return (
    <div className="field--name-field-banner">
      <p>{text}</p>
    </div>
  )
}

export default InternationalPricingNote
